export default __webpack_public_path__ + "static/media/H2HCardImage.2a384225.png";